import * as React from 'react';

export function SvgDiagramSymbolDecision() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M7.13181 0.316373C7.63597 -0.0950409 8.36398 -0.0950409 8.86814 0.316373L8.97263 0.410123L15.5888 7.02633L15.6826 7.13083C16.094 7.63499 16.094 8.36299 15.6826 8.86715L15.5888 8.97165L8.97263 15.5879C8.46913 16.0913 7.67186 16.1223 7.13181 15.6816L7.02731 15.5879L0.411104 8.97165C-0.125804 8.43469 -0.125804 7.56329 0.411104 7.02633L7.02731 0.410123L7.13181 0.316373ZM1.56149 7.99899L7.99997 14.4375L14.4384 7.99899L7.99997 1.56051L1.56149 7.99899Z"
          fill="#6B6E76"
        />
      </svg>
    </span>
  );
}
